import { FC } from 'react'
import { Box } from '@mui/material'
import { ColoursObj, Icon, Typography } from '@eventr/common-storybook'

type TNumberSelectorProps = {
    count: number
    onAdd: () => void
    onSubtract: () => void
    range: [number, number] /// highest and lowest allowed value
}

export const NumberSelector: FC<TNumberSelectorProps> = ({
    count,
    onAdd,
    onSubtract,
    range,
}) => {
    return (
        <Box display={'grid'} gridAutoFlow={'column'} gap={'16px'}>
            <Box
                onClick={() => {
                    if (count !== range[0]) {
                        onSubtract()
                    }
                }}
            >
                <Icon
                    name="Subtract"
                    iconColour={
                        count === range[0]
                            ? ColoursObj.shades.shade2
                            : ColoursObj.core.secondary
                    }
                />
            </Box>
            <Box>
                <Typography>{count}</Typography>
            </Box>
            <Box
                onClick={() => {
                    if (count !== range[1]) {
                        onAdd()
                    }
                }}
            >
                <Icon
                    name="Add"
                    iconColour={
                        count === range[1]
                            ? ColoursObj.shades.shade2
                            : ColoursObj.core.secondary
                    }
                />
            </Box>
        </Box>
    )
}
